import { DeleteWithToken, GetWithToken, PostWithToken, PatchWithToken } from "../../lib/request";

export const createNewBankPromotion = (data) => {
    return async function (dispatch) {
        const result = await PostWithToken('/v2/admin/bank-promotions', data);
        return result;
    }
}

export const getAllBankPromotions = (query) => {
    return async function (dispatch) {
        const limit = query?.limit || 10;
        const offset = query?.offset || 0;
        const result = await GetWithToken(`/v2/admin/bank-promotions?limit=${limit}&offset=${offset}`);
        return result;
    }
}

export const getBankPromotionById = (id) => {
    return async function (dispatch) {
        const result = await GetWithToken(`/v2/admin/bank-promotions/${id}`);
        return result;
    }
}

export const updateBankPromotionById = (id, data) => {
    return async function (dispatch) {
        const result = await PatchWithToken(`/v2/admin/bank-promotions/${id}`, data);
        return result;
    }
}

export const deleteBankPromotionById = (id) => {
    return async function (dispatch) {
        const result = await DeleteWithToken(`/v2/admin/bank-promotions/${id}`);
        return result;
    }
}
